import React from 'react'

export const Margin = ({ top, bottom, left, right, children }) => {
  return (
    <div
      style={{
        marginTop: top,
        marginBottom: bottom,
        marginLeft: left,
        marginRight: right,
      }}
    >
      {children}
    </div>
  )
}
